/* eslint-disable react/prop-types */
import "../../../css/RecruitmentScreen/CheckboxGrid.css"; // Import the CSS for the grid layout
import { useState, useEffect } from "react"; // Import the useState and useEffect hooks
import {
  addSubmissionListener,
  getIsSubmitted,
} from "../../HomeScreen/components/Utils/submissionListener"; // Import the helper functions

const CheckboxGrid = ({
  options = [],
  columns = 2,
  formDataKey,
  selectedOptions = [],
  error,
  disabled = false,
  handleCheckboxChange,
}) => {
  const [isSubmitted, setIsSubmitted] = useState(getIsSubmitted());

  useEffect(() => {
    // Add a listener to track submission status updates
    const removeListener = addSubmissionListener(setIsSubmitted);
    setIsSubmitted(getIsSubmitted());
    // console.log("Is Submitted Form Field", isSubmitted);
    // console.log(isSubmitted === true ? false : readOnly);
    return () => removeListener(); // Clean up the listener on unmount
  }, [getIsSubmitted()]);
  return (
    <div className="checkbox-grid">
      {options.map((option, index) => (
        <div
          key={index}
          className="checkbox-option"
          onClick={() => {
            if (!(isSubmitted === true ? true : disabled)) {
              const syntheticEvent = {
                target: {
                  checked: !selectedOptions.includes(option),
                  value: option,
                  name: formDataKey,
                },
              };
              handleCheckboxChange(syntheticEvent, formDataKey, option);
            }
          }}
          style={{
            cursor: (isSubmitted === true ? true : disabled)
              ? "not-allowed"
              : "pointer",
          }}
        >
          <input
            type="checkbox"
            name={formDataKey}
            value={option}
            onChange={(e) => handleCheckboxChange(e, formDataKey, option)}
            checked={selectedOptions.includes(option)}
            disabled={isSubmitted === true ? true : disabled}
            onClick={(e) => e.stopPropagation()}
          />
          <div className="Content">{option}</div>
        </div>
      ))}
      {/* <span className="error-message">{error}</span> */}
    </div>
  );
};

export default CheckboxGrid;
